import { RootStoreModel } from "@redux/reducers";
import { Col, Dropdown, FloatButton, Layout, Menu, Row, Space } from 'antd';
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from 'react-router';
import { MSALObjLogin } from "../auth/authInstance";
import "./pages.scss";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

function IndexPage() {
  const user = useSelector((state: RootStoreModel) => state.userState);
  const history = useHistory()

  const { t } = useTranslation();

  var paddingWidth = (document.body.clientWidth - 1200) > 0 ? (document.body.clientWidth - 1200) / 2 : 8
  useEffect(() => {
    console.log("屏幕宽和高", document.body.clientWidth, document.body.clientHeight)
  }, [])
  const login = (e: any) => {
    e.preventDefault();
    MSALObjLogin();
  };

  return (
    (<Layout style={{ minWidth: 1200 }} >
      <FloatButton.BackTop />
      <a id="index"></a>
      <div className="bgBox indexPadding" style={{ width: "100%", height: 74, paddingRight: paddingWidth, paddingLeft: paddingWidth,marginTop:0
      }}>
        <Row style={{padding:16}}>
          <Col span={17}>
            <Space
              align="baseline"
              style={{
                alignItems: "center",
                verticalAlign: "baseline"
              }}
            >
              <div  className="indexTopCom imgCenter" style={{ color: "#000", fontSize: 26 }}>
              {process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <img className="imgCenter" style={{width:70,marginLeft:88}} src="/images/title.jpg"></img>
              }
              {!process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <img className="imgCenter" style={{height:35,marginLeft:88}} src="/images/title.jpg"></img>
              }
              {process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <span style={{marginLeft:16,fontWeight:600}}>{t("未瓴")}</span>
              }
              {!process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <span style={{marginLeft:16,fontWeight:600}}>{t("未瓴")}</span>
              }
              </div>
              <div className="indexTopNav" ><a href="#index" style={{ color: "#666",fontSize:16,textDecoration: 'none' }}>{t("首页")}</a></div>
              <div className="indexTopNav" ><a href="#product" style={{ color: "#666",fontSize:16,textDecoration: 'none' }}>{t("产品")}</a></div>
              <div className="indexTopNav" ><a href="#about" style={{ color: "#666",fontSize:16,textDecoration: 'none' }}>{t("关于我们")}</a></div>
              <div className="indexTopNav" ><a href="/contactus" style={{ color: "#666",fontSize:16,textDecoration: 'none' }}>{t("联系我们")}</a></div>
              </Space>
          </Col>
          <Col span={6} style={{ textAlign: "right", margin: "auto",paddingLeft:38 }}>
            <div className="indexTopNav" style={{display: "flex",width:"100%", gap: "32px"}}>
              {user.isLogin ? (
                <a  href="/home/index"  className="indexButton" style={{fontSize:16,textDecoration: 'none'}} >{t("控制台")}</a>
              ) : (

                <a  href="/login"   className="indexButton" style={{fontSize:16,textDecoration: 'none'}} >{t("Sign in")}</a>
              )}
             {!user.isLogin && (<a  href="/register"  style={{backgroundColor:"#3B89FE",color:"#fff",paddingLeft:4,paddingRight:4,fontSize:16,textDecoration: 'none'}} className="indexButton" >{t("注册")}</a>)}
              <Dropdown  placement="bottomCenter" dropdownRender={() => (
                <Menu onClick={(e) => { i18n.changeLanguage(e.key);console.log("i18n",i18n) }} selectable={true} defaultSelectedKeys={[i18n.language]}>
                  <Menu.Item key="zh" style={{width: 145, textAlign: "center"}}>中文</Menu.Item>
                  <Menu.Item key="en" style={{width: 145, textAlign: "center"}}>English</Menu.Item>
                </Menu>
              )}>
                <div style={{marginLeft:16}}>
                  <img style={{height:16}} src="/images/index/language.png" alt="" />
                </div>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </div>
      <a id="device"></a>
      <div className="indexPadding"  style={{ width: "100%",marginTop:0, paddingRight: paddingWidth, paddingLeft: paddingWidth ,borderRadius:16}}>
        <div  className="bgBox" style={{backgroundImage:"url(images/index/bg1.png)",height:600,marginLeft:88,marginRight:88,borderRadius:16}}>
          <div style={{fontSize:i18n.language=="zh"?32:22,fontWeight:600,paddingTop:240,marginLeft:40}}>
          {t("在工作学习中管理")}、<br/>
          {t("保护移动设备")}
          </div>
          <a href="/register" style={{display:"inline-block",fontSize:22,backgroundColor:"#1070FE",width:120,height:38,marginLeft:40,marginTop:20,color:"#fff",paddingLeft:16,textDecoration: 'none'}}>{t("免费试用")}</a>
        </div>
      </div>
      <div className="indexPadding"  style={{ width: "100%",paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
        <Row style={{width:"100%", paddingLeft: 88, paddingRight: 88}}>
          <Col span={10} style={{fontSize:19,padding:"80px 10px 20px 10px",paddingTop:i18n.language=="zh"?80:40}}>
          {t("未瓴移动设备管理平台是一款全面的移动设备管理解决方案，旨在帮助企业员工学校学生有效利用移动设备工作和学习在不影响信息安全的前提下提高生产力，可以让你管理智能手机、笔记本电脑、平板电脑和台式机等")}
          </Col>
          <Col span={14}>
            <img style={{height:300,marginRight:0,float:"right",borderRadius:16}} src="/images/index/bg2.jpg"></img>
          </Col>
        </Row>
      </div>
      <a id="product"></a>
      <div className="bgBox indexPadding" style={{ width: "100%",  paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
        <div >
          <h2 className="deviceContentText1">{t("统一的移动管理")}</h2>
        </div>
        <Space size={16} style={{ paddingLeft: 40, paddingRight: 40, marginTop: 20 }} wrap>
          <div className="devicePlatformBox1">
            <Row className="devicePlatformBox2">
                <img src="images/index/ios.png"></img>
            </Row>
            <p className="devicePlatformText3" >{t("iPhone, iPad 等iOS 设备")}</p>
          </div>
          <div className="devicePlatformBox1">
            <Row className="devicePlatformBox2">
                <img src="images/index/android.png"></img>
            </Row>
            <p className="devicePlatformText3" >{t("基于安卓系统的手机，平板以及各种定制化的智能硬件设备")}</p>
          </div>
          <div className="devicePlatformBox1">
            <Row className="devicePlatformBox2">
                <img src="images/index/macOS.png"></img>
            </Row>
            <p className="devicePlatformText3">{t("MacBook，iMac等Mac设备")}</p>
          </div>
        </Space>
      </div>
      {/* <div className="indexPadding"  style={{ width: "100%", height: 400, paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
        <div >
          <h2 className="deviceContentText1">{t("客户说")}</h2>
        </div>
        <Row style={{width:"100%", paddingLeft: 88, paddingRight: 88,marginTop:50}}>
        <Col span={10}>
            <img style={{height:300,marginRight:0,float:"right"}} src="/images/index/bg2.jpg"></img>
          </Col>
          <Col span={14} style={{fontSize:19,padding:"80px 10px 20px 32px"}}>
          未瓴移动设备管理平台帮我们解决了企业设备管理的难题，
设备完全做到了可控可管。
          </Col>

        </Row>
      </div> */}
      <a id="about"></a>
      <div className="indexPadding"  style={{ width: "100%", paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
        <div >
          <h2 className="deviceContentText1">{t("关于未瓴")}</h2>
        </div>
        <div  className="bgBox" style={{backgroundImage:"url(images/index/bg3.jpg)",height:600,marginLeft:88,marginRight:88,borderRadius:16}}>
          <div style={{fontSize:20,fontWeight:500,lineHeight:"30px",paddingTop:i18n.language=="zh"?180:140,marginLeft:280,marginRight:240}}>
          {t("深圳未瓴科技有限公司是专注于企业信息化尤其是企业移动信息化领域的高科技企业。未瓴科技由深耕行业二十多年的顶级专家团队领衔，深刻洞察企业信息化领域的变化、痛点、诉求，并提供与之相应的整体解决方案。从移动终端管理、数字化转型到智能家居乃至万物有灵的物联网解决方案，未瓴科技都扮演着至关重要的参与者、推动者和领导者的关键角色。")}
          </div>
  
        </div>
      </div>
      <a id="contact"></a>
      <div className="indexPadding" style={{ marginTop:36,backgroundColor: "#242424", width: "100%", height: 215, paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
   
        <Row style={{ marginTop: 16 }}>
          <Col span={6} style={{ textAlign: "center" }}>
            <p><a className="deviceContactText1"> {t("关注我们")}</a></p>
            <img className="deviceContactImage" src="images/willingqrcode.jpg"></img>
          </Col>
          <Col span={8}>
            <p className="deviceContactText2">{t("联系我们")}：</p>
            <p><a className="deviceContactText2" href="mailto:mdm@willingtek.com">mdm@willingtek.com</a></p>
            <p className="deviceContactText2">{t("工作时间")}：</p>
            <p className="deviceContactText2">{t("周一")}~{t("周日")} 9:00-21:00</p>
          </Col>
          <Col span={8}>
            <p className="deviceContactText2">Copyright@2024  {t("深圳未瓴科技有限公司")}</p>
            <p className="deviceContactText2">粤ICP备2024242499号</p>
          </Col>
        </Row>

      </div>
    </Layout>)
  );
}

export default IndexPage;
